import React from 'react'
import { BsInstagram, BsGithub } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
            <a href='https://github.com/Jn-Fr' target='_blank'><BsGithub /></a>
        </div>
        <div>
            <a href='https://www.instagram.com/jnfrx._/' target='_blank'><BsInstagram /></a>
        </div>
        <div>
            <a href='https://www.facebook.com/JnFr.06/' target='_blank'><FaFacebookF /></a>
        </div>
    </div>
  )
}

export default SocialMedia